import {
  FormFieldType,
  FormQuestion,
} from "../../../events-screen/event-page-models/form-question";
import { SelectMenuOption } from "../../../../form/select-menu/select-menu.component";

export const discountPaymentOptions: SelectMenuOption[] = [
  {
    key: "1",
    text: "עד תשלום 1",
    customValue: 1,
  },
  //create array of 12 numbers from 2 to 12
  ...Array.from({ length: 12 }, (_, i) => i + 2).map((num) => ({
    key: num.toString(),
    text: ` עד ${num} תשלומים `,
    customValue: num,
  })),
];

export const newDiscountFormQuestionsContent: FormQuestion[] = [
  {
    fieldName: "numberOfPayments",
    placeHolder: "",
    selectItems: discountPaymentOptions,
    label: "פריסה לתשלומים",
    order: 0,
    isRequired: true,
    fieldType: FormFieldType.Select,
    selectedOption: discountPaymentOptions[0],
    value: discountPaymentOptions[0].key,
  },
  {
    fieldName: "passedCommittee",
    placeHolder: "",
    label: "האם הסבסוד עבר ועדת סבסודים?",
    order: 0,
    isRequired: false,
    fieldType: FormFieldType.Checkbox,
    value: "",
  },
  {
    fieldName: "comments",
    placeHolder: "הערות במידה ויש",
    label: "הערות",
    order: 0,
    isRequired: false,
    fieldType: FormFieldType.LongText,
    value: "",
  },
];



// WEBPACK FOOTER //
// ./src/app/admin/discounts/new-discount-form-select-price/new-discount-form-questions/new-discount-form-questions.ts